import aframe from "aframe";
import level from "./level";
import gameState from "./game-state";
import instructions from "./instructions";
import { bindEvent } from "aframe-event-decorators";

aframe.registerComponent("game-paused", {
  init() {
    this.gameStateEl = document.querySelector('[game-state]');
    this.gameBoardEl = document.querySelector("#game-board");
    this.timeWarpControlEl = document.querySelector("#timeWarpControl");
    this.highScoresEl = document.querySelector('#highScoreTable');
    this.jukeboxEl = document.querySelector('[jukebox]');

    this.mustPauseLevel = false;
    this.curEvt = undefined;
    this.debugPause = this.el.sceneEl.getAttribute("debug-pause");
    this.delayButtonProcess = undefined;
    this.curState = '';
  },

  vrbuttonup: bindEvent(function(evt) {
    const buttonId = evt.target.id;
    this._endPause(buttonId);
    if (buttonId === 'abortButton') {
      if (this.curState === 'Playing' || this.curState === 'LevelComplete')
        this._mainMenu();
      else
        this.delayButtonProcess = () => this._mainMenu();
    } else if (buttonId === 'endButton') {
      if (this.curState === 'Playing' || this.curState === 'LevelComplete')
        this._gameOver();
      else
        this.delayButtonProcess = () => this._gameOver();
    }
  }),

  _mainMenu() {
    instructions.instance.stop();
    this.gameStateEl.removeAttribute('level');
    this.timeWarpControlEl.setAttribute('visible', false);
    this.highScoresEl.setAttribute('visible', true);
    this.jukeboxEl.setAttribute("jukebox", { state: "on" });
    this.gameStateEl.setAttribute("game-state", { state: "MainMenu" });
  },

  _gameOver() {
    instructions.instance.stop();
    this.timeWarpControlEl.setAttribute('visible', false);
    this.jukeboxEl.setAttribute("jukebox", { state: "on" });
    this.gameStateEl.setAttribute("game-state", { state: "GameOver" });
  },

  startPause: bindEvent(function (evt) {
    this.curEvt = evt.detail;
    this.gameBoardEl.pause();
    // Can only pause the level once the game state element has a 'level' attribute.
    // Otherwise we have to wait for the event to be generated
    if (this.gameStateEl.getAttribute('level'))
      level.instance.pause();
    else
      this.mustPauseLevel = true;
    gameState.instance.pause();
    if (evt.detail.displayPause && this.debugPause === 'off') {
      this.jukeboxEl.setAttribute("jukebox", { state: "pause" });
      this.gameBoardEl.setAttribute('visible', false);
      this.el.setAttribute('visible', true);
    }
    this.gameStateEl.emit('pauseStarted');
  }),

  endPause: bindEvent(function (evt) {
    this.curEvt = evt.detail;
    this._endPause();
  }),

  _endPause(buttonId) {
    const alarmEl = document.querySelector('[misound__alarm]');
    const alarmSound = alarmEl.components.misound__alarm;
    if (buttonId !== 'resumeButton' && alarmSound.isPaused)
      alarmSound.stopSound();
    this.el.setAttribute('visible', false);
    this.gameBoardEl.setAttribute('visible', true);
    this.mustPauseLevel = false;
    gameState.instance.play();
    if (level.instance) level.instance.play();
    this.gameBoardEl.play();
    if (this.curEvt && this.curEvt.endCallback)
      this.curEvt.endCallback();
    if (this.curState !== 'Loading' && this.curState !== 'MainMenu')
      this.jukeboxEl.setAttribute("jukebox", { state: "on" });
    this.gameStateEl.emit('pauseEnded');
  },

  newLevelPlaying: bindEvent({ target: '[game-state]' }, function () {
    if (this.mustPauseLevel) {
      // A level instance has been created since we started the pause.
      // Make sure that the level is also paused.
      // Note: Can't just check for state change to 'Playing' as need to
      //       wait for level to be anchored.
      this.mustPauseLevel = false;
      level.instance.pause();
    }
    if (this.delayButtonProcess) {
      this.delayButtonProcess();
      this.delayButtonProcess = undefined;
    }
  }),

  gamestatechanged: bindEvent({ target: '[game-state]' }, function (evt) {
    const newState = this.curState = evt.detail;
    if (newState === 'NewGame') {
      this.mustPauseLevel = false;
      this.curEvt = undefined;
      this.delayButtonProcess = undefined;
    }
  })
});
